export default __webpack_public_path__ + "static/Corvallis Logo-959196f9bd61713bcc8bdb9c8fbfeec5.png";